import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_yandexmetrikaplugin6639358c_54ec85ee from 'nuxt_plugin_yandexmetrikaplugin6639358c_54ec85ee' // Source: ./yandex-metrika.plugin.6639358c.js (mode: 'client')
import nuxt_plugin_vlazyload_05e305eb from 'nuxt_plugin_vlazyload_05e305eb' // Source: ./v-lazy-load.js (mode: 'all')
import nuxt_plugin_vuescrollto_8c6d86a8 from 'nuxt_plugin_vuescrollto_8c6d86a8' // Source: ./vue-scrollto.js (mode: 'client')
import nuxt_plugin_nuxtsvgsprite_d0b404ca from 'nuxt_plugin_nuxtsvgsprite_d0b404ca' // Source: ./nuxt-svg-sprite.js (mode: 'all')
import nuxt_plugin_pluginutils_f00215c4 from 'nuxt_plugin_pluginutils_f00215c4' // Source: ./nuxt-i18n/plugin.utils.js (mode: 'all')
import nuxt_plugin_pluginrouting_3a16b2e9 from 'nuxt_plugin_pluginrouting_3a16b2e9' // Source: ./nuxt-i18n/plugin.routing.js (mode: 'all')
import nuxt_plugin_pluginmain_4ca76db4 from 'nuxt_plugin_pluginmain_4ca76db4' // Source: ./nuxt-i18n/plugin.main.js (mode: 'all')
import nuxt_plugin_workbox_f91536ce from 'nuxt_plugin_workbox_f91536ce' // Source: ./workbox.js (mode: 'client')
import nuxt_plugin_metaplugin_581102ac from 'nuxt_plugin_metaplugin_581102ac' // Source: ./pwa/meta.plugin.js (mode: 'all')
import nuxt_plugin_iconplugin_5cb8a820 from 'nuxt_plugin_iconplugin_5cb8a820' // Source: ./pwa/icon.plugin.js (mode: 'all')
import nuxt_plugin_axios_7824aabd from 'nuxt_plugin_axios_7824aabd' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_cookieuniversalnuxt_7ff33065 from 'nuxt_plugin_cookieuniversalnuxt_7ff33065' // Source: ./cookie-universal-nuxt.js (mode: 'all')
import nuxt_plugin_Plugincacheclient56e4c255_10eaf9c0 from 'nuxt_plugin_Plugincacheclient56e4c255_10eaf9c0' // Source: ./Plugin.cache.client.56e4c255.js (mode: 'client')
import nuxt_plugin_Plugincacheserver86c39846_701af2f0 from 'nuxt_plugin_Plugincacheserver86c39846_701af2f0' // Source: ./Plugin.cache.server.86c39846.js (mode: 'server')
import nuxt_plugin_googleanalytics_79c8f56e from 'nuxt_plugin_googleanalytics_79c8f56e' // Source: ./google-analytics.js (mode: 'client')
import nuxt_plugin_router_40bd3892 from 'nuxt_plugin_router_40bd3892' // Source: ./router.js (mode: 'all')
import nuxt_plugin_nuxtuseragent_16a0603e from 'nuxt_plugin_nuxtuseragent_16a0603e' // Source: ../plugins/nuxt-user-agent.js (mode: 'all')
import nuxt_plugin_globalbasecomponents_17edb10a from 'nuxt_plugin_globalbasecomponents_17edb10a' // Source: ../plugins/global.base.components.js (mode: 'all')
import nuxt_plugin_vtooltip_781f7596 from 'nuxt_plugin_vtooltip_781f7596' // Source: ../plugins/vtooltip.js (mode: 'client')
import nuxt_plugin_globalhelpers_2704fdee from 'nuxt_plugin_globalhelpers_2704fdee' // Source: ../plugins/global.helpers.js (mode: 'client')
import nuxt_plugin_globalmodal_0ab39da1 from 'nuxt_plugin_globalmodal_0ab39da1' // Source: ../plugins/global.modal.js (mode: 'client')
import nuxt_plugin_globalfilters_289547d3 from 'nuxt_plugin_globalfilters_289547d3' // Source: ../plugins/global.filters.js (mode: 'all')
import nuxt_plugin_vuetouch_b2d0d29a from 'nuxt_plugin_vuetouch_b2d0d29a' // Source: ../plugins/vue-touch.js (mode: 'client')
import nuxt_plugin_alert_e8e2b47c from 'nuxt_plugin_alert_e8e2b47c' // Source: ../plugins/ui/alert.js (mode: 'client')
import nuxt_plugin_vuesticky_24fd6673 from 'nuxt_plugin_vuesticky_24fd6673' // Source: ../plugins/vue-sticky.js (mode: 'client')
import nuxt_plugin_copyright_14757678 from 'nuxt_plugin_copyright_14757678' // Source: ../plugins/copyright.js (mode: 'client')
import nuxt_plugin_axios_397e53b5 from 'nuxt_plugin_axios_397e53b5' // Source: ../plugins/axios.js (mode: 'all')
import nuxt_plugin_clipboard_08485495 from 'nuxt_plugin_clipboard_08485495' // Source: ../plugins/clipboard.js (mode: 'all')
import nuxt_plugin_veevalidation_45101d73 from 'nuxt_plugin_veevalidation_45101d73' // Source: ../plugins/vee-validation.js (mode: 'all')
import nuxt_plugin_swiper_076f49ea from 'nuxt_plugin_swiper_076f49ea' // Source: ../plugins/swiper.js (mode: 'all')
import nuxt_plugin_bus_24831a6b from 'nuxt_plugin_bus_24831a6b' // Source: ../plugins/bus.js (mode: 'all')
import nuxt_plugin_authEmit_28d10c08 from 'nuxt_plugin_authEmit_28d10c08' // Source: ../plugins/authEmit.js (mode: 'all')
import nuxt_plugin_auth_435f9a5a from 'nuxt_plugin_auth_435f9a5a' // Source: ./auth.js (mode: 'all')
import nuxt_plugin_userLoggedIn_737fbd11 from 'nuxt_plugin_userLoggedIn_737fbd11' // Source: ../plugins/userLoggedIn.js (mode: 'all')
import nuxt_plugin_authrefreshToken_51091d07 from 'nuxt_plugin_authrefreshToken_51091d07' // Source: ../plugins/auth.refreshToken.js (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root.$options.$nuxt
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const router = await createRouter(ssrContext, config)

  const store = createStore(ssrContext)
  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  store.registerModule = registerModule

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"htmlAttrs":{"class":"html"},"bodyAttrs":{"class":"body app"},"title":"","meta":[{"name":"viewport","content":"width=device-width, initial-scale=1, maximum-scale=1"},{"hid":"description","name":"description","content":""},{"hid":"og:description","name":"og:description","skip":true},{"name":"yandex-verification","content":"864390629708b1cd"},{"name":"yandex-verification","content":"8f69b303e9d3ea98"}],"link":[{"rel":"preload","href":"\u002Ffonts\u002Fsubset-Geometria.woff2","as":"font","type":"font\u002Fwoff2","crossorigin":true},{"rel":"preload","href":"\u002Ffonts\u002Fsubset-Geometria-Medium.woff2","as":"font","type":"font\u002Fwoff2","crossorigin":true},{"rel":"icon","type":"image\u002Fx-icon","href":"\u002Fimg\u002Ffavicon\u002F120x120.ico"},{"rel":"icon","type":"image\u002Fsvg+xml","sizes":"any","href":"\u002Fimg\u002Ffavicon\u002F72x72.svg"},{"rel":"icon","type":"image\u002Fpng","href":"\u002Fimg\u002Ffavicon\u002F120x120.png"},{"rel":"apple-touch-icon-precomposed","sizes":"152x152","href":"\u002Fimg\u002Ffavicon\u002F152x152.png"},{"rel":"apple-touch-icon-precomposed","sizes":"144x144","href":"\u002Fimg\u002Ffavicon\u002F144x144.png"},{"rel":"apple-touch-icon-precomposed","sizes":"120x120","href":"\u002Fimg\u002Ffavicon\u002F120x120.png"},{"rel":"apple-touch-icon-precomposed","sizes":"114x114","href":"\u002Fimg\u002Ffavicon\u002F114x114.png"},{"rel":"apple-touch-icon-precomposed","sizes":"76x76","href":"\u002Fimg\u002Ffavicon\u002F76x76.png"},{"rel":"apple-touch-icon-precomposed","sizes":"72x72","href":"\u002Fimg\u002Ffavicon\u002F72x72.png"},{"href":"https:\u002F\u002Fmc.yandex.ru\u002Fmetrika\u002Ftag.js","rel":"preload","as":"script"}],"script":[{"type":"application\u002Fld+json","json":{"@context":"http:\u002F\u002Fwww.schema.org","@type":"Organization","url":"https:\u002F\u002Faromo.ru\u002F","sameAs":["https:\u002F\u002Fwww.youtube.com\u002Fc\u002Faromolive","https:\u002F\u002Fwww.instagram.com\u002Faromo.ru\u002F","https:\u002F\u002Ft.me\u002Faromo_ru","https:\u002F\u002Fwww.facebook.com\u002Faromo.ru\u002F","https:\u002F\u002Fvk.com\u002Faromo_ru","https:\u002F\u002Ftwitter.com\u002Faromo_ru","https:\u002F\u002Fok.ru\u002Faromo.ru"],"logo":"https:\u002F\u002Faromo.ru\u002Fimg\u002Flogo.png","description":"Aromo.ru ─ это уникальный проект, объединивший поклонников парфюмерного искусства и профессионалов индустрии. На страницах Аромо мы собираем самые актуальные новости и мнения экспертов, исследуем тенденции, рассказываем о важнейших событиях и публикуем авторские обзоры значимых ароматов.","address":{"@type":"PostalAddress","streetAddress":"Севастопольский проспект 12-4-74","addressLocality":"Москва","postalCode":"127018","addressCountry":"Россия"},"contactPoint":{"@type":"ContactPoint","telephone":"8 (800) 505-35-16","contactType":"office"}}}],"style":[]},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (process.client && typeof nuxt_plugin_yandexmetrikaplugin6639358c_54ec85ee === 'function') {
    await nuxt_plugin_yandexmetrikaplugin6639358c_54ec85ee(app.context, inject)
  }

  if (typeof nuxt_plugin_vlazyload_05e305eb === 'function') {
    await nuxt_plugin_vlazyload_05e305eb(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuescrollto_8c6d86a8 === 'function') {
    await nuxt_plugin_vuescrollto_8c6d86a8(app.context, inject)
  }

  if (typeof nuxt_plugin_nuxtsvgsprite_d0b404ca === 'function') {
    await nuxt_plugin_nuxtsvgsprite_d0b404ca(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginutils_f00215c4 === 'function') {
    await nuxt_plugin_pluginutils_f00215c4(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginrouting_3a16b2e9 === 'function') {
    await nuxt_plugin_pluginrouting_3a16b2e9(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginmain_4ca76db4 === 'function') {
    await nuxt_plugin_pluginmain_4ca76db4(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_workbox_f91536ce === 'function') {
    await nuxt_plugin_workbox_f91536ce(app.context, inject)
  }

  if (typeof nuxt_plugin_metaplugin_581102ac === 'function') {
    await nuxt_plugin_metaplugin_581102ac(app.context, inject)
  }

  if (typeof nuxt_plugin_iconplugin_5cb8a820 === 'function') {
    await nuxt_plugin_iconplugin_5cb8a820(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_7824aabd === 'function') {
    await nuxt_plugin_axios_7824aabd(app.context, inject)
  }

  if (typeof nuxt_plugin_cookieuniversalnuxt_7ff33065 === 'function') {
    await nuxt_plugin_cookieuniversalnuxt_7ff33065(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_Plugincacheclient56e4c255_10eaf9c0 === 'function') {
    await nuxt_plugin_Plugincacheclient56e4c255_10eaf9c0(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_Plugincacheserver86c39846_701af2f0 === 'function') {
    await nuxt_plugin_Plugincacheserver86c39846_701af2f0(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_googleanalytics_79c8f56e === 'function') {
    await nuxt_plugin_googleanalytics_79c8f56e(app.context, inject)
  }

  if (typeof nuxt_plugin_router_40bd3892 === 'function') {
    await nuxt_plugin_router_40bd3892(app.context, inject)
  }

  if (typeof nuxt_plugin_nuxtuseragent_16a0603e === 'function') {
    await nuxt_plugin_nuxtuseragent_16a0603e(app.context, inject)
  }

  if (typeof nuxt_plugin_globalbasecomponents_17edb10a === 'function') {
    await nuxt_plugin_globalbasecomponents_17edb10a(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vtooltip_781f7596 === 'function') {
    await nuxt_plugin_vtooltip_781f7596(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_globalhelpers_2704fdee === 'function') {
    await nuxt_plugin_globalhelpers_2704fdee(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_globalmodal_0ab39da1 === 'function') {
    await nuxt_plugin_globalmodal_0ab39da1(app.context, inject)
  }

  if (typeof nuxt_plugin_globalfilters_289547d3 === 'function') {
    await nuxt_plugin_globalfilters_289547d3(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuetouch_b2d0d29a === 'function') {
    await nuxt_plugin_vuetouch_b2d0d29a(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_alert_e8e2b47c === 'function') {
    await nuxt_plugin_alert_e8e2b47c(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuesticky_24fd6673 === 'function') {
    await nuxt_plugin_vuesticky_24fd6673(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_copyright_14757678 === 'function') {
    await nuxt_plugin_copyright_14757678(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_397e53b5 === 'function') {
    await nuxt_plugin_axios_397e53b5(app.context, inject)
  }

  if (typeof nuxt_plugin_clipboard_08485495 === 'function') {
    await nuxt_plugin_clipboard_08485495(app.context, inject)
  }

  if (typeof nuxt_plugin_veevalidation_45101d73 === 'function') {
    await nuxt_plugin_veevalidation_45101d73(app.context, inject)
  }

  if (typeof nuxt_plugin_swiper_076f49ea === 'function') {
    await nuxt_plugin_swiper_076f49ea(app.context, inject)
  }

  if (typeof nuxt_plugin_bus_24831a6b === 'function') {
    await nuxt_plugin_bus_24831a6b(app.context, inject)
  }

  if (typeof nuxt_plugin_authEmit_28d10c08 === 'function') {
    await nuxt_plugin_authEmit_28d10c08(app.context, inject)
  }

  if (typeof nuxt_plugin_auth_435f9a5a === 'function') {
    await nuxt_plugin_auth_435f9a5a(app.context, inject)
  }

  if (typeof nuxt_plugin_userLoggedIn_737fbd11 === 'function') {
    await nuxt_plugin_userLoggedIn_737fbd11(app.context, inject)
  }

  if (typeof nuxt_plugin_authrefreshToken_51091d07 === 'function') {
    await nuxt_plugin_authrefreshToken_51091d07(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
